import {
  calculateAbsoluteCouponDiscount,
  calculateTotalMonthlyPriceAfterCouponDiscount,
  generateCouponDiscountText,
  parsePriceWithUnit,
} from '../my-pricing.logic';
import { useSelector } from 'react-redux';
import { getPersonalizedSubscriptionData } from 'logic/store/elitetutor/elitetutor.selectors';
import { useParams } from 'react-router-dom';

export const useCouponDiscountPrices = (
  totalPriceWithoutCoupon: number | null,
  yourPrice:
    | {
        currency: string;
        unitAmount: number;
      }
    | undefined,
  allowedDiscountTypes?: (string | null | undefined)[]
): {
  absoluteNegativeCouponDiscountWithUnit: string | null;
  priceAfterCouponDiscountWithUnit: string | null;
  couponDiscountText: string | null;
} => {
  const { token: personalizedSubscriptionToken } = useParams<{ token: string }>();
  const personalizedSubscriptionData = useSelector(getPersonalizedSubscriptionData);

  if (
    totalPriceWithoutCoupon == null ||
    personalizedSubscriptionToken == null ||
    personalizedSubscriptionData == null
  ) {
    return {
      absoluteNegativeCouponDiscountWithUnit: null,
      priceAfterCouponDiscountWithUnit: null,
      couponDiscountText: null,
    };
  }

  let discount = personalizedSubscriptionData.discount;
  if (allowedDiscountTypes?.length && !allowedDiscountTypes.includes(discount?.type)) {
    discount = undefined;
  }

  const absoluteCouponDiscount = calculateAbsoluteCouponDiscount(totalPriceWithoutCoupon, discount);
  const totalPriceAfterCouponDiscount = calculateTotalMonthlyPriceAfterCouponDiscount(
    totalPriceWithoutCoupon,
    absoluteCouponDiscount
  );
  const absoluteCouponDiscountWithUnit = parsePriceWithUnit(
    absoluteCouponDiscount,
    yourPrice?.currency
  );
  const absoluteNegativeCouponDiscountWithUnit = parsePriceWithUnit(
    absoluteCouponDiscount ? -absoluteCouponDiscount : null,
    yourPrice?.currency
  );
  const priceAfterCouponDiscountWithUnit = parsePriceWithUnit(
    totalPriceAfterCouponDiscount,
    yourPrice?.currency
  );
  const couponDiscountText = generateCouponDiscountText(
    personalizedSubscriptionData,
    absoluteCouponDiscountWithUnit
  );

  return {
    absoluteNegativeCouponDiscountWithUnit,
    priceAfterCouponDiscountWithUnit,
    couponDiscountText,
  };
};
